// eslint-disable-next-line import/prefer-default-export
export const getColumnOrder = (state, table = 'default') => state.tableColumnOrder[table];
